import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import "./notices.css";

const Notices = ({ section }) => {
  const location = useLocation();
  const currentSection = section || location.pathname.split('/')[2];

  let content = '';

  switch (currentSection) {
    case 'privacycenter':
      content = (
        <>
          <h1>Privacy Center</h1>
          <p>
            This is the Privacy Center where we explain how we collect, use, and protect your personal data.
            Your privacy is important to us, and we are committed to transparency regarding your data.
            Please read through our policies to understand how we handle your information and your rights.
          </p>
        </>
      );
      break;

    case 'termsandconditions':
      content = (
        <>
          <h1>Terms & Conditions</h1>
          <p>
            These Terms & Conditions govern the use of our website and services. By accessing or using our website,
            you agree to comply with these terms. Please review these terms carefully before using our services.
            If you have any questions, feel free to contact us.
          </p>
        </>
      );
      break;

    case 'privacypolicy':
      content = (
        <>
          <h1>Privacy Policy</h1>
          <p>
            Our Privacy Policy outlines how we collect, store, and use your data. We are dedicated to protecting
            your privacy and ensuring your information is secure. Please read this policy to learn more about our
            practices and how you can control your information.
          </p>
        </>
      );
      break;

    default:
      content = (
        <>
          <h1>Not Found</h1>
          <p>The page you are looking for does not exist.</p>
        </>
      );
  }

  return (
    <div className="notices-container">
      <Link to="/#home" className="back-nav"> ↩ Back to Home</Link>
      {content}
    </div>
  );
};

export default Notices;
